// Market Information
export const marketData = {
  diamondPrices: {
    current: 142.5,
    change: 3.2,
    trend: "up",
    history: [
      { period: "Q1 2024", price: 128 },
      { period: "Q2 2024", price: 131 },
      { period: "Q3 2024", price: 135 },
      { period: "Q4 2024", price: 138 },
      { period: "Q1 2025", price: 140 },
      { period: "Q2 2025", price: 139 },
      { period: "Q3 2025", price: 141 },
      { period: "Q4 2025", price: 143 },
      { period: "Q1 2026", price: 142.5 },
    ],
  },
  angolaEconomy: {
    gdpGrowth: 2.8,
    inflation: 14.2,
    exchangeRate: 825,
    oilPrice: 78.5,
    miningContribution: 8.2,
  },
  industryMetrics: {
    globalProduction: 119,
    angolaShare: 8.5,
    demandGrowth: 2.1,
    labGrownShare: 18.2,
  },
};

// Chatbot suggested questions
export const suggestedQuestionsData = {
  en: [
    "What is the current EBITDA margin and how does it compare to last year?",
    "What are the main risks affecting cash flow?",
    "How is CAPEX execution progressing vs plan?",
    "What is driving the variance in production vs plan?",
    "Summarize the key financial highlights for the Management",
  ],
  pt: [
    "Qual é a margem EBITDA actual e como se compara com o ano passado?",
    "Quais são os principais riscos que afectam o cash flow?",
    "Como está a progredir a execução do CAPEX vs plano?",
    "O que está a causar o desvio na produção vs plano?",
    "Resumir os principais destaques financeiros para a Gerência",
  ],
};
